import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { PortDeparturesRow } from '../interfaces/vesselDepartures.interface';

export const vesselDeparturesApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<PortDeparturesRow[]> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/vessel-departures', { params });
    return (response.data?.data as PortDeparturesRow[]) ?? [];
  },
};
